import { createAction } from 'redux-actions';

export const setTOCExpandAll = createAction('SET_TOC_EXPAND_ALL');
export const setTOCRefresh = createAction('SET_TOC_REFRESH');
